export const invalidParametersError = {
  title: 'Invalid Parameters',
  message: 'Please try again from your IDE'
};

export const defaultError = {
  title: 'Unexpected error',
  message: 'Please try again from your IDE'
};

export const signInError = {
  title: 'Failed to sign in',
  message:
    'This session appears to have expired, please sign in again from your IDE'
};

export const oauthError = {
  title: 'Error signing in',
  message: 'There was an error signing in, please sign in again from your IDE'
};

export const inviteError = {
  title: 'Unable to invite team member',
  message: 'There was an error inviting a team member, please try again later'
};

export const paymentLinkError = {
  title: 'Invalid payment link',
  message: 'Please try again from your IDE'
};

export const missingOrgError = {
  title: 'Missing organization',
  message: 'Please try again from your IDE'
};

export const paddleProductsError = {
  title: 'Missing products',
  message: 'Please try again later'
};

export const invalidPlanError = {
  title: 'Invalid plan',
  message:
    'You have selected an invalid plan, please try again from the plans page'
};
